import React, { useEffect } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Dialog, DialogContent, DialogTitle, DialogActions, Typography, Divider } from '@material-ui/core'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import ConsignmentDetailsFormProperties from './ConsignmentDetailsFormProperties'
import ConsignmentDetailsMakeValidationSchema from './ConsignmentDetailsMakeValidationSchema'

const {
  button: { CngButton }
} = components

function ConsignmentDetailsDialog(props) {
  const { consignmentDetails, isView, onAddConsignmentDetails, onEditConsignmentDetails, open, onClose, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const title = translate(Namespace.UAE_MPCI, UaeMpciKeys.ConsignmentDetails.TITLE)
  const saveButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.SAVE_BUTTON)

  const validationSchema = ConsignmentDetailsMakeValidationSchema(translate)

  const methods = useForm({
    defaultValues: ConsignmentDetailsFormProperties.formikProps.initialValues,
    resolver: yupResolver(validationSchema)
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    if (open) {
      if (consignmentDetails) {
        reset(consignmentDetails)
      } else {
        reset(ConsignmentDetailsFormProperties.formikProps.initialValues)
      }
    }
  }, [open, consignmentDetails])

  function onSubmit(data) {
    if (consignmentDetails) {
      onEditConsignmentDetails(data)
    } else {
      onAddConsignmentDetails(data)
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography variant="h5"><strong>{title}</strong></Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <FormProvider {...methods}>
          <form>
            <ConsignmentDetailsFormProperties.Fields disabled={isView} />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <CngButton color="secondary" onClick={onClose} size="medium">Cancel</CngButton>
        {!isView && (
          <CngButton color="primary" onClick={handleSubmit(onSubmit)} size="medium">
            {consignmentDetails ? 'Update' : saveButton}
          </CngButton>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ConsignmentDetailsDialog
